const CITY_COMPONENT_TYPES = [
  'locality',
  'postal_town',
  'administrative_area_level_3',
  'sublocality_level_1',
  'sublocality',
  'neighborhood',
  'administrative_area_level_2',
  'administrative_area_level_1',
];

const findComponent = (results, type) => {
  for (const result of results) {
    const components = Array.isArray(result.address_components) ? result.address_components : [];
    const component = components.find(item => Array.isArray(item.types) && item.types.includes(type));

    if (component && component.long_name) {
      return component;
    }
  }

  return null;
};

const findPoliticalFallback = results => {
  for (const result of results) {
    const components = Array.isArray(result.address_components) ? result.address_components : [];
    const component = components.find(
      item =>
        item.long_name &&
        Array.isArray(item.types) &&
        item.types.includes('political') &&
        !item.types.includes('country')
    );

    if (component) {
      return component;
    }
  }

  return null;
};

export const extractPlaceFromGeocodingResults = rawResults => {
  const results = Array.isArray(rawResults) ? rawResults : [];
  const countryComponent = findComponent(results, 'country');
  const cityComponent =
    CITY_COMPONENT_TYPES.map(type => findComponent(results, type)).find(Boolean) ||
    findPoliticalFallback(results);
  const country = countryComponent
    ? countryComponent.long_name.replace('The Bahamas', 'Bahamas')
    : '';
  const city = cityComponent && cityComponent.long_name !== country ? cityComponent.long_name : '';

  return {
    city,
    country,
    countryCode: countryComponent ? countryComponent.short_name || '' : '',
  };
};

